import { Type } from '@sinclair/typebox';
import { makeNullable } from '../../utils/typeboxHelpers';

export const surveyInvestigationPaths = {
    '/api/surveyInvestigations': {
        get: {
            operationId: 'surveyControllers.getFurtherInvestigation',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                items: Type.Array(
                                    Type.Object({
                                        objectId: Type.String(),
                                        surveyId: Type.String(),
                                        surveryedOn: Type.String(),
                                        code: makeNullable(Type.String()),
                                        name: Type.String(),
                                        location: Type.String(),
                                        description: Type.String(),
                                        priority: makeNullable(Type.String()),
                                    }),
                                ),
                            }),
                        },
                    },
                },
            },
        },
    },
} as const;
